import type { UseFormRegister } from "react-hook-form";
import type { CreateProductionOrderRequest } from "@opus-dt/shared-types";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

// Campos opcionais de texto da OP (responsável + observações). Extraído do
// ProductionOrderForm para mantê-lo ≤200 LOC efetivas (Guardrail #1).
export function ProductionOrderNotesFields({
  register,
}: {
  register: UseFormRegister<CreateProductionOrderRequest>;
}) {
  return (
    <>
      <div className="space-y-2">
        <Label htmlFor="po-resp">
          Responsável <span className="text-[11px] font-normal text-text-tertiary">· opcional</span>
        </Label>
        <Input id="po-resp" {...register("responsible")} />
      </div>

      <div className="space-y-2">
        <Label htmlFor="po-obs">
          Observações <span className="text-[11px] font-normal text-text-tertiary">· opcional</span>
        </Label>
        <textarea
          id="po-obs"
          rows={2}
          {...register("observations")}
          className="w-full rounded-md border bg-card px-3 py-2 text-sm"
        />
      </div>
    </>
  );
}
